import {
  formatDateAsDayOfMonthAndFullWeekday,
  formatDateAsYearMonthDay,
  formatDateTimeAsFullMonthDayAndWeekYear,
  formatDateTimeAsYearMonthDayTwelveHour,
} from './dateFormatters';
import type { GridCellFormatRequest, GridCellFormatter } from './types';

type FormattersByFormat = ReadonlyMap<string, GridCellFormatter>;

const gridCellFormatterRegistry: ReadonlyMap<string, FormattersByFormat> = new Map([
  [
    'date',
    new Map([
      ['yyyy/MM/dd', formatDateAsYearMonthDay],
      ['d EEEE', formatDateAsDayOfMonthAndFullWeekday],
    ]),
  ],
  [
    'datetime',
    new Map([
      ['yyyy/MM/dd hh:mm a', formatDateTimeAsYearMonthDayTwelveHour],
      ['MMMM d, YYYY', formatDateTimeAsFullMonthDayAndWeekYear],
    ]),
  ],
]);

export const formatGridCellValue = ({
  value,
  dataType,
  format,
}: GridCellFormatRequest): string | null => {
  if (!dataType || !format) return null;

  const formatter = gridCellFormatterRegistry.get(dataType.toLowerCase())?.get(format);
  if (!formatter) return null;

  try {
    return formatter(value);
  } catch {
    return null;
  }
};
